import { render, staticRenderFns } from "./call-schedule-call-log-list.vue?vue&type=template&id=52c11ad5&"
import script from "./call-schedule-call-log-list.vue?vue&type=script&lang=js&"
export * from "./call-schedule-call-log-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports